
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const IVTherapy = () => {
  const treatmentData = {
    title: "IV Therapy",
    subtitle: "Vitamin infusions for wellness, energy, and glowing skin",
    description: "Our IV therapy treatments deliver essential vitamins, minerals, and antioxidants directly into your bloodstream for maximum absorption and immediate benefits.",
    whoItsFor: [
      "Those feeling fatigued or run down",
      "People wanting immune system support",
      "Anyone seeking enhanced hydration",
      "Clients wanting glowing skin from within",
      "Those with busy, stressful lifestyles"
    ],
    packages: [
      {
        name: "Glow IV",
        visitorPrice: "$200",
        memberPrice: "$180",
        description: "Vitamin C, Biotin, and Glutathione for radiant skin"
      },
      {
        name: "Energy Boost IV",
        visitorPrice: "$250",
        memberPrice: "$225",
        description: "B-complex vitamins for sustained energy"
      },
      {
        name: "Immunity IV",
        visitorPrice: "$300",
        memberPrice: "$270",
        description: "High-dose Vitamin C and Zinc for immune support"
      }
    ],
    beforeCare: [
      "Eat a light meal before treatment",
      "Stay hydrated",
      "Wear comfortable clothing",
      "Bring entertainment for relaxation time"
    ],
    duringCare: [
      "Comfortable IV insertion",
      "Relax in our luxury treatment room",
      "30-45 minute infusion time",
      "Monitor vitals throughout treatment"
    ],
    afterCare: [
      "Stay hydrated for 24 hours",
      "Avoid strenuous exercise for 2 hours",
      "Remove bandage after 2 hours",
      "Effects typically felt within hours"
    ],
    memberPerks: [
      "10% discount on all IV therapy packages",
      "Complimentary wellness consultation",
      "Priority booking for regular treatments",
      "Access to exclusive IV blends",
      "Free add-on vitamins with series packages"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default IVTherapy;
